import Section from "../Section";
import BookMeeting from "../BookMeeting";
/*import "./Contact.scss";*/

const Contact = () => (
  <Section id="submit" className="Contact">
    <div className="container my-0 py-0">
      <div className="ContactInner">
        <div className="row my-0 py-0">
          <div className="col-lg-7 my-0 py-0">
            <h1>Contact Us</h1>
            <div
              id="customForm"
              className="form p-0"
              dangerouslySetInnerHTML={{
                __html: `<script src="https://js-eu1.hsforms.net/forms/embed/147703054.js" defer></script><div class="hs-form-frame" data-region="eu1" data-form-id="ca95e9c0-bb62-4a74-89e0-4c4292efc1d7" data-portal-id="147703054"></div>`,
              }}
              suppressHydrationWarning
            />
          </div>
          <div className="col-lg-5 my-0 py-0">
            <BookMeeting />
          </div>
        </div>
      </div>
    </div>
  </Section>
);

export default Contact;
